
export class AmadeusModel {
  fc_method: string;
  fc_oid: string;
  fc_iata: string;
  fc_request: string;
  fc_response: string;
}

